// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiDefaultResponse {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiDefaultResponse.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiDefaultResponse.discriminator = undefined;
PharmacyV1PharmacyBiDefaultResponse.additionalProperties = false;
PharmacyV1PharmacyBiDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyV1PharmacyBiDefaultResponseData"
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiDefaultResponse.js.map